<template>
    
</template>

<script>
    export default {
        name: "RowsMixin",
        methods: {
            setRows (eventData) {
                this.changeMyData({ rows: eventData.value});
                this.setChangesAreSaved(false);
            },
            getRows () {
                return this.myData.rows;
            },
        }
    }
</script>

